import { siteUrl } from '@config'
import { useLocation } from '@reach/router'
import React, { type FC } from 'react'

import { SEO_IDS } from './constants'

export const MetaUrl: FC = () => {
  const location = useLocation()
  const url = `${siteUrl}${location.pathname}`

  return (
    <>
      <meta content={url} id={SEO_IDS.OG_URL} name="og:url" />
      <link href={url} id={SEO_IDS.CANONICAL} rel="canonical" />
    </>
  )
}
